export const FEATURE_APPROVAL_STATUS: { [key: number]: number[] } = {
  3: [1, 2, 3, 4, 5, 6],
  4: [3, 4, 5, 6],
};

export const DEFAULT_APPROVAL_STATUS_ID = 6; // UNSENT
export const INVENTORY_APPROVAL_STATUS = 'inventory_approval_status';
export const INSPECTION_APPROVAL_STATUS = 'inspection_approval_status';
